import React from 'react'
import PropTypes from 'prop-types'

export default function PlayerHistoryBackButton({ onBack }) {
  return (
    <div className="row">
      <div className="col-12 text-center">
        <button
          onClick={onBack}
          className="btn btn-outline-primary"
          aria-label="Navigate back to previous page"
        >
          ← Back
        </button>
      </div>
    </div>
  )
}

PlayerHistoryBackButton.propTypes = {
  onBack: PropTypes.func.isRequired,
}
